// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { z as zod } from 'zod';

/**
 * getAll users
 * @summary Get All Users
 */
export const getAllUsersQueryParams = zod.object({
  page: zod.coerce.number().optional(),
  pageSize: zod.coerce.number().optional(),
  sort: zod.coerce.string().optional(),
  filter: zod.coerce.string().optional(),
});

export const getAllUsersResponse = zod
  .object({
    data: zod
      .array(
        zod
          .object({
            username: zod.string(),
            firstname: zod.string(),
            lastname: zod.string(),
            email: zod.string(),
            role: zod.enum(['admin', 'lecturer', 'student']),
            state: zod.enum(['active', 'stale', 'finished', 'inactive']).optional(),
            active: zod.boolean().optional(),
            title: zod.string().or(zod.null()).optional(),
            trial: zod
              .object({
                isTrial: zod.boolean().optional(),
                startdate: zod.string().datetime().or(zod.null()).optional(),
                durationDays: zod.number().or(zod.null()).optional(),
                message: zod.string().or(zod.null()).optional(),
                ctaLink: zod.string().or(zod.null()).optional(),
                ctaLabel: zod.string().or(zod.null()).optional(),
                trialActive: zod.boolean(),
              })
              .strict()
              .or(zod.null())
              .optional(),
            cohort: zod
              .object({
                id: zod.string(),
                title: zod.string(),
                state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
                isDeprecated: zod.boolean().optional(),
                stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
              })
              .strict()
              .or(zod.null())
              .optional(),
            context: zod
              .object({
                currentModule: zod
                  .object({
                    moduleId: zod.string(),
                    courseId: zod.string().or(zod.null()).optional(),
                    currentTaskId: zod.string().or(zod.null()).optional(),
                  })
                  .strict()
                  .or(zod.null())
                  .optional(),
                activity: zod
                  .array(
                    zod
                      .object({
                        userId: zod.string().or(zod.null()).optional(),
                        timestamp: zod.string().datetime().optional(),
                        activity: zod.enum([
                          'open_module',
                          'open_task',
                          'close_task',
                          'complete_task',
                          'submit_module',
                          'store_draft',
                          'login',
                          'impersonate',
                        ]),
                        courseId: zod.string().or(zod.null()).optional(),
                        moduleId: zod.string().or(zod.null()).optional(),
                        taskId: zod.string().or(zod.null()).optional(),
                        impersonatedBy: zod.string().or(zod.null()).optional(),
                        data: zod
                          .record(zod.string(), zod.string().or(zod.number()).or(zod.number()))
                          .or(zod.null())
                          .optional(),
                      })
                      .strict(),
                  )
                  .or(zod.null())
                  .optional(),
              })
              .strict()
              .or(zod.null())
              .optional(),
            avatar: zod.string().or(zod.null()).optional(),
            profilePhotoBlobPath: zod.string().or(zod.null()).optional(),
            features: zod.record(zod.string(), zod.boolean()).optional(),
            externalStudentId: zod.string().or(zod.null()).optional(),
            id: zod.string(),
            notificationPrefs: zod
              .object({
                email: zod
                  .object({
                    preferences: zod.record(zod.string(), zod.boolean()).optional(),
                  })
                  .strict()
                  .optional(),
              })
              .strict()
              .optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Create new user
 * @summary Create User
 */
export const createUserBody = zod
  .object({
    username: zod.string().or(zod.null()).optional(),
    firstname: zod.string(),
    lastname: zod.string(),
    email: zod.string(),
    role: zod.string().or(zod.null()).optional(),
    state: zod.enum(['active', 'stale', 'finished', 'inactive']).optional(),
    active: zod.boolean().or(zod.null()).optional(),
    title: zod.string().or(zod.null()).optional(),
    trial: zod
      .object({
        isTrial: zod.boolean().optional(),
        startdate: zod.string().datetime().or(zod.null()).optional(),
        durationDays: zod.number().or(zod.null()).optional(),
        message: zod.string().or(zod.null()).optional(),
        ctaLink: zod.string().or(zod.null()).optional(),
        ctaLabel: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    cohort: zod
      .object({
        id: zod.string(),
        title: zod.string(),
        state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
        isDeprecated: zod.boolean().optional(),
        stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
      })
      .strict()
      .or(
        zod
          .object({
            id: zod.string().or(zod.null()).optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    context: zod
      .object({
        currentModule: zod
          .object({
            moduleId: zod.string(),
            courseId: zod.string().or(zod.null()).optional(),
            currentTaskId: zod.string().or(zod.null()).optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        activity: zod
          .array(
            zod
              .object({
                userId: zod.string().or(zod.null()).optional(),
                timestamp: zod.string().datetime().optional(),
                activity: zod.enum([
                  'open_module',
                  'open_task',
                  'close_task',
                  'complete_task',
                  'submit_module',
                  'store_draft',
                  'login',
                  'impersonate',
                ]),
                courseId: zod.string().or(zod.null()).optional(),
                moduleId: zod.string().or(zod.null()).optional(),
                taskId: zod.string().or(zod.null()).optional(),
                impersonatedBy: zod.string().or(zod.null()).optional(),
                data: zod
                  .record(zod.string(), zod.string().or(zod.number()).or(zod.number()))
                  .or(zod.null())
                  .optional(),
              })
              .strict(),
          )
          .or(zod.null())
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    avatar: zod.string().or(zod.null()).optional(),
    profilePhotoBlobPath: zod.string().or(zod.null()).optional(),
    features: zod.record(zod.string(), zod.boolean()).optional(),
    externalStudentId: zod.string().or(zod.null()).optional(),
    password: zod.string().or(zod.null()).optional(),
    course: zod
      .object({
        id: zod.string().or(zod.null()).optional(),
        externalProductId: zod.string().or(zod.null()).optional(),
        extraModuleIds: zod.array(zod.string()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    sendWelcomeEmail: zod.boolean().optional(),
    includePassword: zod.boolean().optional(),
  })
  .strict();

/**
 * Get user and their activity context
 * @summary Get User
 */
export const getUserParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getUserResponse = zod
  .object({
    data: zod
      .object({
        username: zod.string(),
        firstname: zod.string(),
        lastname: zod.string(),
        email: zod.string(),
        role: zod.enum(['admin', 'lecturer', 'student']),
        state: zod.enum(['active', 'stale', 'finished', 'inactive']).optional(),
        active: zod.boolean().optional(),
        title: zod.string().or(zod.null()).optional(),
        trial: zod
          .object({
            isTrial: zod.boolean().optional(),
            startdate: zod.string().datetime().or(zod.null()).optional(),
            durationDays: zod.number().or(zod.null()).optional(),
            message: zod.string().or(zod.null()).optional(),
            ctaLink: zod.string().or(zod.null()).optional(),
            ctaLabel: zod.string().or(zod.null()).optional(),
            trialActive: zod.boolean(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        cohort: zod
          .object({
            id: zod.string(),
            title: zod.string(),
            state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
            isDeprecated: zod.boolean().optional(),
            stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        context: zod
          .object({
            currentModule: zod
              .object({
                moduleId: zod.string(),
                courseId: zod.string().or(zod.null()).optional(),
                currentTaskId: zod.string().or(zod.null()).optional(),
              })
              .strict()
              .or(zod.null())
              .optional(),
            activity: zod
              .array(
                zod
                  .object({
                    userId: zod.string().or(zod.null()).optional(),
                    timestamp: zod.string().datetime().optional(),
                    activity: zod.enum([
                      'open_module',
                      'open_task',
                      'close_task',
                      'complete_task',
                      'submit_module',
                      'store_draft',
                      'login',
                      'impersonate',
                    ]),
                    courseId: zod.string().or(zod.null()).optional(),
                    moduleId: zod.string().or(zod.null()).optional(),
                    taskId: zod.string().or(zod.null()).optional(),
                    impersonatedBy: zod.string().or(zod.null()).optional(),
                    data: zod
                      .record(zod.string(), zod.string().or(zod.number()).or(zod.number()))
                      .or(zod.null())
                      .optional(),
                  })
                  .strict(),
              )
              .or(zod.null())
              .optional(),
          })
          .strict()
          .or(zod.null())
          .optional(),
        avatar: zod.string().or(zod.null()).optional(),
        profilePhotoBlobPath: zod.string().or(zod.null()).optional(),
        features: zod.record(zod.string(), zod.boolean()).optional(),
        externalStudentId: zod.string().or(zod.null()).optional(),
        id: zod.string(),
        notificationPrefs: zod
          .object({
            email: zod
              .object({
                preferences: zod.record(zod.string(), zod.boolean()).optional(),
              })
              .strict()
              .optional(),
          })
          .strict()
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * update existing user with all passed fields
 * @summary Update User
 */
export const updateUserParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const updateUserBody = zod
  .object({
    firstname: zod.string().or(zod.null()).optional(),
    lastname: zod.string().or(zod.null()).optional(),
    email: zod.string().or(zod.null()).optional(),
    cohort: zod
      .object({
        id: zod.string(),
        title: zod.string(),
        state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
        isDeprecated: zod.boolean().optional(),
        stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
      })
      .strict()
      .or(
        zod
          .object({
            id: zod.string().or(zod.null()).optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    role: zod.string().or(zod.null()).optional(),
    title: zod.string().or(zod.null()).optional(),
    active: zod.boolean().or(zod.null()).optional(),
    state: zod.enum(['active', 'stale', 'finished', 'inactive']).or(zod.null()).optional(),
    features: zod.record(zod.string(), zod.boolean()).or(zod.null()).optional(),
    trial: zod
      .object({
        isTrial: zod.boolean().optional(),
        startdate: zod.string().datetime().or(zod.null()).optional(),
        durationDays: zod.number().or(zod.null()).optional(),
        message: zod.string().or(zod.null()).optional(),
        ctaLink: zod.string().or(zod.null()).optional(),
        ctaLabel: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    notificationPrefs: zod
      .object({
        email: zod
          .object({
            preferences: zod.record(zod.string(), zod.boolean()).optional(),
          })
          .strict()
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    externalStudentId: zod.string().or(zod.null()).optional(),
  })
  .strict();

export const updateUserResponse = zod.any();

/**
 * update existing user, only passed fields are updated
 * @summary Patch User
 */
export const patchUserParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const patchUserBody = zod
  .object({
    firstname: zod.string().or(zod.null()).optional(),
    lastname: zod.string().or(zod.null()).optional(),
    email: zod.string().or(zod.null()).optional(),
    cohort: zod
      .object({
        id: zod.string(),
        title: zod.string(),
        state: zod.enum(['active', 'stale', 'retired']).or(zod.null()).optional(),
        isDeprecated: zod.boolean().optional(),
        stateChangedAt: zod.string().datetime().or(zod.null()).optional(),
      })
      .strict()
      .or(
        zod
          .object({
            id: zod.string().or(zod.null()).optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    role: zod.string().or(zod.null()).optional(),
    title: zod.string().or(zod.null()).optional(),
    active: zod.boolean().or(zod.null()).optional(),
    state: zod.enum(['active', 'stale', 'finished', 'inactive']).or(zod.null()).optional(),
    features: zod.record(zod.string(), zod.boolean()).or(zod.null()).optional(),
    trial: zod
      .object({
        isTrial: zod.boolean().optional(),
        startdate: zod.string().datetime().or(zod.null()).optional(),
        durationDays: zod.number().or(zod.null()).optional(),
        message: zod.string().or(zod.null()).optional(),
        ctaLink: zod.string().or(zod.null()).optional(),
        ctaLabel: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    notificationPrefs: zod
      .object({
        email: zod
          .object({
            preferences: zod.record(zod.string(), zod.boolean()).optional(),
          })
          .strict()
          .optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    externalStudentId: zod.string().or(zod.null()).optional(),
  })
  .strict();

export const patchUserResponse = zod.any();

/**
 * delete user
 * @summary Delete User
 */
export const deleteUserParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const deleteUserResponse = zod.any();

/**
 * Trigger a password reset email for a user (admin only).
 * @summary Trigger Password Reset
 */
export const triggerPasswordResetParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const triggerPasswordResetResponse = zod.any();

/**
 * Return the catalog of available (configurable) notification kinds for the user.

Excludes whitelisted/mandatory kinds; does not include effective state.
 * @summary Get Available Notification Kinds
 */
export const getAvailableNotificationKindsParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getAvailableNotificationKindsResponse = zod
  .object({
    data: zod
      .object({
        channels: zod.array(zod.string()).optional(),
        kinds: zod
          .array(
            zod
              .object({
                code: zod.string(),
                category: zod.string(),
                description: zod.string(),
              })
              .strict(),
          )
          .optional(),
        preferences: zod.record(zod.string(), zod.record(zod.string(), zod.boolean())).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * log user activity
 * @summary Log User Activity
 */
export const logUserActivityParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const logUserActivityBody = zod
  .object({
    userId: zod.string().or(zod.null()).optional(),
    timestamp: zod.string().datetime().optional(),
    activity: zod.enum([
      'open_module',
      'open_task',
      'close_task',
      'complete_task',
      'submit_module',
      'store_draft',
      'login',
      'impersonate',
    ]),
    courseId: zod.string().or(zod.null()).optional(),
    moduleId: zod.string().or(zod.null()).optional(),
    taskId: zod.string().or(zod.null()).optional(),
    impersonatedBy: zod.string().or(zod.null()).optional(),
    data: zod.record(zod.string(), zod.string().or(zod.number()).or(zod.number())).or(zod.null()).optional(),
  })
  .strict();

export const logUserActivityResponse = zod.any();

/**
 * get user activity
 * @summary Get User Activity
 */
export const getUserActivityParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getUserActivityResponse = zod
  .object({
    data: zod
      .array(
        zod
          .object({
            userId: zod.string().or(zod.null()).optional(),
            timestamp: zod.string().datetime().optional(),
            activity: zod.enum([
              'open_module',
              'open_task',
              'close_task',
              'complete_task',
              'submit_module',
              'store_draft',
              'login',
              'impersonate',
            ]),
            courseId: zod.string().or(zod.null()).optional(),
            moduleId: zod.string().or(zod.null()).optional(),
            taskId: zod.string().or(zod.null()).optional(),
            impersonatedBy: zod.string().or(zod.null()).optional(),
            data: zod.record(zod.string(), zod.string().or(zod.number()).or(zod.number())).or(zod.null()).optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * List all active mandates (Evaluator or Facilitator) for the user.
 * @summary Get User Mandates
 */
export const getUserMandatesParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getUserMandatesResponse = zod
  .object({
    data: zod
      .array(
        zod
          .object({
            moduleId: zod.string(),
            moduleTitle: zod.string(),
            roleTitle: zod.string(),
            eventKindId: zod.string().or(zod.null()).optional(),
            eventKindLabel: zod.string().or(zod.null()).optional(),
            planningStatus: zod.enum(['ok', 'minor', 'critical']).or(zod.null()).optional(),
            planningReason: zod.string().or(zod.null()).optional(),
            missingCount: zod.number().or(zod.null()).optional(),
            segments: zod
              .array(
                zod
                  .object({
                    periodStartLocal: zod.string(),
                    periodEndLocal: zod.string(),
                    availableSlots: zod.number(),
                    isFilled: zod.boolean(),
                  })
                  .strict(),
              )
              .or(zod.null())
              .optional(),
          })
          .strict(),
      )
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * List all students currently in the lecturer's mandates pipeline.
 * @summary Get My Students
 */
export const getMyStudentsParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getMyStudentsResponse = zod
  .object({
    data: zod
      .object({
        records: zod.array(
          zod
            .object({
              student: zod
                .object({
                  id: zod.string(),
                  firstname: zod.string(),
                  lastname: zod.string(),
                  email: zod.string(),
                  role: zod.enum(['admin', 'lecturer', 'student']),
                  state: zod.enum(['active', 'stale', 'finished', 'inactive']).optional(),
                  cohortId: zod.string().or(zod.null()).optional(),
                  cohortTitle: zod.string().or(zod.null()).optional(),
                })
                .strict(),
              moduleId: zod.string(),
              moduleTitle: zod.string(),
              moduleVersion: zod.string(),
              courseId: zod.string(),
              workState: zod.enum(['active', 'stalled', 'waiting', 'submitted', 'completed']),
              levelProgress: zod
                .record(
                  zod.string(),
                  zod
                    .object({
                      total: zod.number(),
                      completed: zod.number(),
                      taskStates: zod.array(zod.string()),
                      taskIds: zod.array(zod.string()).optional(),
                    })
                    .strict(),
                )
                .optional(),
              lastActivity: zod.string().datetime().or(zod.null()),
            })
            .strict(),
        ),
        totalCount: zod.number(),
        stateCounts: zod.record(zod.string(), zod.number()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Return shareable contact settings for the owner.
 * @summary Get People Profile
 */
export const getPeopleProfileParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getPeopleProfileResponse = zod
  .object({
    data: zod
      .object({
        shareEmail: zod.string().or(zod.null()).optional(),
        phone: zod.string().or(zod.null()).optional(),
        whatsapp: zod.string().or(zod.null()).optional(),
        sharePhone: zod.boolean().optional(),
        shareWhatsapp: zod.boolean().optional(),
        showPhotoToConnections: zod.boolean().optional(),
        openToConnectGss: zod.boolean().optional(),
        profilePhotoBlobPath: zod.string().or(zod.null()).optional(),
        firstName: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Persist shareable contact and visibility preferences.
 * @summary Patch People Profile
 */
export const patchPeopleProfileParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const patchPeopleProfileBody = zod
  .object({
    shareEmail: zod.string().or(zod.null()).optional(),
    phone: zod.string().or(zod.null()).optional(),
    whatsapp: zod.string().or(zod.null()).optional(),
    sharePhone: zod.boolean().or(zod.null()).optional(),
    shareWhatsapp: zod.boolean().or(zod.null()).optional(),
    showPhotoToConnections: zod.boolean().or(zod.null()).optional(),
    openToConnectGss: zod.boolean().or(zod.null()).optional(),
    clearProfilePhoto: zod.boolean().or(zod.null()).optional(),
  })
  .strict();

export const patchPeopleProfileResponse = zod
  .object({
    data: zod
      .object({
        shareEmail: zod.string().or(zod.null()).optional(),
        phone: zod.string().or(zod.null()).optional(),
        whatsapp: zod.string().or(zod.null()).optional(),
        sharePhone: zod.boolean().optional(),
        shareWhatsapp: zod.boolean().optional(),
        showPhotoToConnections: zod.boolean().optional(),
        openToConnectGss: zod.boolean().optional(),
        profilePhotoBlobPath: zod.string().or(zod.null()).optional(),
        firstName: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Upload a JPEG profile photo to user-photos storage.
 * @summary Upload People Profile Photo
 */
export const uploadPeopleProfilePhotoParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const uploadPeopleProfilePhotoBody = zod
  .object({
    imageBase64: zod.string().min(1),
  })
  .strict();

export const uploadPeopleProfilePhotoResponse = zod
  .object({
    data: zod
      .object({
        shareEmail: zod.string().or(zod.null()).optional(),
        phone: zod.string().or(zod.null()).optional(),
        whatsapp: zod.string().or(zod.null()).optional(),
        sharePhone: zod.boolean().optional(),
        shareWhatsapp: zod.boolean().optional(),
        showPhotoToConnections: zod.boolean().optional(),
        openToConnectGss: zod.boolean().optional(),
        profilePhotoBlobPath: zod.string().or(zod.null()).optional(),
        firstName: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Owner-only SAS URL for profile photo display.
 * @summary Get People Profile Photo Url
 */
export const getPeopleProfilePhotoUrlParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getPeopleProfilePhotoUrlResponse = zod
  .object({
    data: zod
      .object({
        url: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Owner-only SAS URL for the account profile photo (oral exam briefing, user menu).
 * @summary Get User Avatar
 */
export const getUserAvatarParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const getUserAvatarResponse = zod
  .object({
    data: zod
      .object({
        url: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();

/**
 * Upload a JPEG account avatar to user-photos storage.
 * @summary Upload User Avatar
 */
export const uploadUserAvatarParams = zod
  .object({
    user_id: zod.coerce.string(),
  })
  .strict();

export const uploadUserAvatarBody = zod
  .object({
    imageBase64: zod.string().min(1),
  })
  .strict();

export const uploadUserAvatarResponse = zod
  .object({
    data: zod
      .object({
        url: zod.string().or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    message: zod.string().or(zod.null()).optional(),
    pagination: zod
      .object({
        total: zod.number(),
        page: zod.number(),
        pageSize: zod.number(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    error: zod
      .object({
        code: zod.string(),
        message: zod.string(),
        details: zod.record(zod.string(), zod.any()).or(zod.null()).optional(),
      })
      .strict()
      .or(zod.null())
      .optional(),
    statusCode: zod.number().optional(),
  })
  .strict();
